module.exports = __webpack_public_path__ + "img/sayfa-cizgi-yesil-2.864857ca.png";